document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.story-video video');
  
  // LAZY LOADING + INTERSECTION OBSERVER OTIMIZADO
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      
      if (entry.isIntersecting) {
        // LAZY LOADING: Carrega o vídeo apenas quando necessário
        if (!video.dataset.loaded) {
          // Para vídeo com data-src
          if (video.dataset.src && !video.src) {
            video.src = video.dataset.src;
          }
          
          // Para múltiplas sources com data-src
          if (video.querySelectorAll('source[data-src]').length > 0) {
            video.querySelectorAll('source[data-src]').forEach(source => {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
            });
          }
          
          // Carrega o vídeo
          if (video.dataset.src || video.querySelectorAll('source[data-src]').length > 0) {
            video.load();
          }
          
          video.dataset.loaded = 'true';
        }
        
        // Play quando visível
        video.play().catch(e => console.log('Autoplay bloqueado:', e));
      } else {
        // Pause quando não visível (economia de bateria/banda)
        video.pause();
      }
    });
  }, {
    threshold: 0.5,
    rootMargin: '100px' // Carrega 100px antes de entrar na tela
  });
  
  videos.forEach(video => {
    // Adiciona classe para CSS loading states
    video.classList.add('lazy-video');
    
    // Observa o vídeo
    videoObserver.observe(video);
    
    // OTIMIZAÇÕES DE PERFORMANCE
    video.setAttribute('preload', 'none'); // Não carrega até necessário
    video.setAttribute('playsinline', 'true'); // Melhor para mobile
    
    // Garantir que o vídeo seja mutado (alguns navegadores são restritivos)
    video.addEventListener('loadeddata', function() {
      this.muted = true;
      this.setAttribute('data-media-loaded', 'true');
    });
    
    // Otimização: Play suave após carregamento
    video.addEventListener('canplaythrough', function() {
      // Só tenta dar play se estiver visível
      const rect = this.closest('.story-video').getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
      
      if (isVisible && this.dataset.loaded) {
        this.play().catch(e => console.log('Autoplay bloqueado:', e));
      }
    }, { once: true }); // Remove listener após primeira execução
    
    // ECONOMIA DE RECURSOS: Remove listeners desnecessários após uso
    video.addEventListener('ended', function() {
      // Opcional: Loop ou ação após término
      if (this.loop) {
        this.currentTime = 0;
        this.play().catch(e => console.log('Loop bloqueado:', e));
      }
    });
  });
  
  // CONTAINER DE STORIES - OTIMIZADO
  const container = document.querySelector('.stories-container');
  if (container) {
    // Remove qualquer comportamento de snap que possa existir
    container.style.scrollSnapType = 'none';
    container.style.scrollBehavior = 'auto';
    
    // DRAG FUNCIONAL OTIMIZADO NO DESKTOP
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;
    
    // Otimização: Throttle para mousemove
    let rafId = null;
    
    container.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      container.style.cursor = 'grabbing';
      container.style.userSelect = 'none'; // Evita seleção de texto
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      
      // Cancela animações anteriores
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    });
    
    container.addEventListener('mouseleave', () => {
      isDown = false;
      isDragging = false;
      container.style.cursor = 'grab';
      container.style.userSelect = '';
      
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    });
    
    container.addEventListener('mouseup', (e) => {
      isDown = false;
      container.style.cursor = 'grab';
      container.style.userSelect = '';
      
      // Evita click em links/botões após drag
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    });
    
    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      
      isDragging = true;
      e.preventDefault();
      
      // Otimização: RequestAnimationFrame para smooth scroll
      if (rafId) return;
      
      rafId = requestAnimationFrame(() => {
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 1.5; // Velocidade do drag
        container.scrollLeft = scrollLeft - walk;
        rafId = null;
      });
    });
    
    // TOUCH EVENTS PARA MOBILE (adicional)
    let touchStartX = 0;
    let touchScrollLeft = 0;
    
    container.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchScrollLeft = container.scrollLeft;
    }, { passive: true });
    
    container.addEventListener('touchmove', (e) => {
      if (!touchStartX) return;
      
      const touchX = e.touches[0].clientX;
      const diff = touchStartX - touchX;
      container.scrollLeft = touchScrollLeft + diff;
    }, { passive: true });
    
    container.addEventListener('touchend', () => {
      touchStartX = 0;
      touchScrollLeft = 0;
    }, { passive: true });
    
    container.style.cursor = 'grab';
    
    // OTIMIZAÇÃO ADICIONAL: Pause vídeos fora da área visível durante scroll
    let scrollTimeout;
    container.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      
      // Throttle scroll events
      scrollTimeout = setTimeout(() => {
        const containerRect = container.getBoundingClientRect();
        
        videos.forEach(video => {
          const videoRect = video.getBoundingClientRect();
          const isInViewport = videoRect.left < containerRect.right && 
                              videoRect.right > containerRect.left;
          
          if (!isInViewport && !video.paused) {
            video.pause();
          }
        });
      }, 100);
    }, { passive: true });
  }
  
  // LIMPEZA DE MEMÓRIA: Remove observers quando necessário
  window.addEventListener('beforeunload', () => {
    videoObserver.disconnect();
    videos.forEach(video => {
      video.pause();
      video.src = '';
      video.load();
    });
  });
});